module.exports = __webpack_public_path__ + "img/lyman-beecher.1cf62c38.png";